<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="来源" prop="source" >
        <a-radio-group disabled v-model="form.source">
          <a-radio :value=1>余额</a-radio>
          <a-radio :value=2>金币</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="审核状态" prop="status" >
        <a-radio-group name="radioGroup" :default-value="2" v-model="form.status">
          <a-radio :value=2>通过</a-radio>
          <a-radio :value=3>驳回</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="提现方式" prop="type" >
        <div v-if="form.type == 1" style="display: flex;flex-direction: column">
<!--          <span>微信账号：{{form.wechatName}}</span>-->
<!--          <span>微信收款码：<img v-viewer  style="width: 48px;height: 48px;margin-top: 5px;margin-right: 5px;" v-if="form.wechatImg"-->
<!--               :src="form.wechatImg" preview="头像"/></span>-->
        </div>
        <div v-if="form.type == 2" style="display: flex;flex-direction: column">
          <span>支付宝账号：{{form.alipayAccount}}</span>
        </div>
        <div v-if="form.type == 3" style="display: flex;flex-direction: column">
          <span>银行卡号：{{form.bankName}}</span>
        </div>
      </a-form-model-item>
      <a-form-model-item label="提现金额" prop="money" >
        <a-input readOnly v-model="form.money" placeholder="请输入提现金额" />
      </a-form-model-item>
      <a-form-model-item label="实际到账金额" prop="arrivalAmount" >
        <a-input readOnly v-model="form.arrivalAmount" placeholder="请输入提现金额" />
      </a-form-model-item>

<!--      <a-form-model-item label="打款证明" prop="prove" v-if="form.status ==2">-->
<!--        <file-upload type="image" :defaultList="form.imgArr1" :count="1"-->
<!--                     @input="getImg($event, 'prove')"></file-upload>-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="驳回原因" v-if="form.status ==3" prop="reason" >
        <a-input v-model="form.reason" placeholder="请输入驳回原因" />
      </a-form-model-item>
<!--      <a-form-model-item label="备注" prop="remark" >-->
<!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getWithdraw, addWithdraw, updateWithdraw } from '@/api/withdraw/withdraw'
import {guid} from "@/utils/ruoyi";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        imgArr1: [],
        id: null,

        userId: null,

        status: 0,

        type: null,
        source:null,
        money: null,
        arrivalAmount:null,
        alipayImage:null,
        alipayName:null,
        bankName:null,
        alipayAccount:null,
        wechatName:null,
        wechatImage:null,
        prove: null,

        reason: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: '用户ID不能为空', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '状态1-待打款 2-已打款 -1-已驳回不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '提现方式 1-微信 2-支付宝不能为空', trigger: 'change' }
        ],
        money: [
          { required: true, message: '提现金额不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        status: 0,
        type: null,
        source:null,
        money: null,
        alipayImage:null,
        arrivalAmount:null,
        alipayAccount:null,
        bankName:null,
        alipayName:null,
        wechatName:null,
        wechatImage:null,
        prove: null,
        reason: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },


    /******************** 上传图片数据处理 start ********************/
    /**前端 需要将图片格式处理成数组，方便数据回显 */
    setImgData(field, img) {
      let fieldImgArr = []
      if (img.indexOf(",") === -1) {
        // 单图
        if (this.form[`${field}Count`] === 1) {
          if (img) {
            fieldImgArr.push({
              uid: guid(8, 10),
              name: img,
              status: 'done',
              halfUrl: img,
              url: img,
              path: img
            })
          }
        }
      } else {
        // 多图
        if (this.form[`${field}Count`] > 1) {
          let imgArr = img.split(",")
          if (imgArr.length) {
            imgArr.map(item => {
              fieldImgArr.push({
                uid: guid(8, 10),
                name: img,
                status: 'done',
                halfUrl: img,
                url: item,
                path: item
              })
            })
          }
        }
      }
      return fieldImgArr
    },
    /**上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].url
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info.map(ele => { return ele.url }).join(",")
          this.form[`${fieldName}Arr`] = info
        }
      }
    },
    /** 点击视频 弹窗打窗口播放视频*/
    async handlePreview(file) {
      this.previewImage = this.form.video || file.video;
      this.previewVisible = true;
      this.$nextTick(() => {
        this.$refs.myVideo.play()
      })
    },
    handleCancel() {
      this.previewVisible = false;
    },
    /******************** 上传图片数据处理 end   ********************/



    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getWithdraw({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateWithdraw(this.form).then(res => {
              if(res.success){
                this.$message.success(
                  '审核成功',
                  3
                )
                this.open = false
                this.$emit('ok')
              }else{
                this.$message.error(res.message)
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addWithdraw(this.form).then(res => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
